/**
 * Comparatorul sortării client-side din DataTable (modul necontrolat, ex.
 * /stocuri „La dată").
 *
 * Valorile lipsă (null/undefined) vin ÎNTOTDEAUNA la sfârșit, indiferent de
 * direcție — aceeași semantică precum `NULLS LAST` din sortările server-side
 * (ex. GET /stock?sort=code), ca un tabel să nu se ordoneze diferit în funcție
 * de cine sortează (serverul sau browserul).
 *
 * `dir`: 1 = crescător, -1 = descrescător.
 */
export function compareSortValues(va: unknown, vb: unknown, dir: 1 | -1): number {
  if (va == null && vb == null) return 0;
  if (va == null) return 1;
  if (vb == null) return -1;
  if (typeof va === 'number' && typeof vb === 'number') return (va - vb) * dir;
  return String(va).localeCompare(String(vb), 'ro') * dir;
}
